import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { UserTokenResponse } from 'src/app/shared-resources/interfaces/base-core-services.interface';
import {
  HttpErrorHandlerService,
  MessageType,
} from 'src/app/shared-resources/services/http-error-handling.service';
import { UserInfoService } from 'src/app/shared-resources/services/user-info.service';

import { BaseApp } from '@subscription-destroyer';
import { LoginRequest } from '../../interfaces/login.interface';
import { ForgotPassService } from '../../services/forgot-password';
import { LoginService } from '../../services/login.service';

export interface CaptchaImageAndKey {
  captchaKey: string;
  encodedCaptchaImage: string;
}

@Component({
  selector: 'app-login-enduser',
  templateUrl: './login-enduser.component.html',
  styleUrls: ['./login-enduser.component.less'],
  providers: [BaseApp],
})
export class LoginEnduserComponent implements OnInit {
  public validateForm: FormGroup;
  public passwordVisible = false;
  public password: string;
  public customRoles = [];
  public captchaImageUrl: string = '';
  public captchaKey: string = '';
  public loading = false;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private loginService: LoginService,
    private translate: TranslateService,
    private httpMessage: HttpErrorHandlerService,
    private userService: UserInfoService,
    private forgotPassService: ForgotPassService,
    private subscription: BaseApp
  ) {}

  signup(): void {
    this.router.navigateByUrl('/signup');
  }

  forgotpassword(): void {
    this.router.navigateByUrl('/forgot-password');
  }

  goto(): void {
    for (const i in this.validateForm.controls) {
      if (i) {
        this.validateForm.controls[i].markAsDirty();
        this.validateForm.controls[i].updateValueAndValidity();
      }
    }
    this.loading = true;
    if (this.validateForm.valid) {
      const loginBody: LoginRequest = {
        username: this.validateForm.value.userName,
        password: this.validateForm.value.password,
        captchaAnswer: this.validateForm.value.captcha,
        captchaKey: this.captchaKey,
      };
      this.subscription.subs.add(
        this.loginService.login(loginBody).subscribe(
          (res: UserTokenResponse) => {
            if (res.isFirstLogin) {
              this.router.navigateByUrl(
                '/admin-reset-password?username=' + res.user.userName
              );
              return;
            }
            if (res.userType === 'consumer_user') {
              this.loginService.setUserData(
                res,
                this.validateForm.value.userName
              );
              sessionStorage.setItem(
                'tokenExpiryTime',
                JSON.stringify(res.token.expiresIn)
              );
              sessionStorage.setItem(
                'tokenExpiryDate',
                moment(new Date())
                  .add(res.token.expiresIn, 'seconds')
                  .toString()
              );
              sessionStorage.setItem('isOTPVerified', 'false');
              this.router.navigateByUrl('/verify-otp');
              this.loading = false;
            } else {
              this.httpMessage.showTopFloatMessage(
                this.translate.instant('app.label.only-user-allowed'),
                MessageType.ERROR,
                this.translate.instant('app.label.unauthorised')
              );
              this.loading = false;
            }
          },
          (error: HttpErrorResponse) => {
            this.getCaptchaImageAndKey();
            this.validateForm.controls.captcha.reset();
            this.httpMessage.showTopFloatMessage(
              error.error,
              MessageType.ERROR,
              this.translate.instant('app.signin.failed.title')
            );
            this.loading = false;
          }
        )
      );
    } else {
      this.loading = false;
      this.validateForm.controls.captcha.reset();
      this.getCaptchaImageAndKey();
    }
  }

  ngOnInit(): void {
    const userName = this.userService.getUserName();
    this.createValidationForm(userName);
    this.getCaptchaImageAndKey();
  }
  createValidationForm(userName: string): void {
    this.validateForm = this.fb.group({
      userName: [
        userName ? userName : '',
        [Validators.required, Validators.pattern(/^[a-z0-9]+$/)],
      ],
      password: ['', [Validators.required]],
      remember: [true],
      captcha: ['', [Validators.required]],
    });
  }

  getCaptchaImageAndKey() {
    this.subscription.subs.add(
      this.forgotPassService
        .getCaptchaImageAndKey()
        .subscribe((res: CaptchaImageAndKey) => {
          this.captchaImageUrl =
            'data:image/jpg;base64,' + res.encodedCaptchaImage;
          this.captchaKey = res.captchaKey;
        })
    );
  }
}
